import { createAction } from '@reduxjs/toolkit';
import { GDriveImportJob } from './model';

export const modalOpened = createAction('creativeHub/googleDriveImport/modalOpened');

export const modalClosed = createAction('creativeHub/googleDriveImport/modalClosed');

export const importSubmitted = createAction<{ link: string }>(
  'creativeHub/googleDriveImport/importSubmitted',
);

export const taskCreationStarted = createAction(
  'creativeHub/googleDriveImport/taskCreationStarted',
);

export const taskCreationFailed = createAction<{ errorMessage: string }>(
  'creativeHub/googleDriveImport/taskCreationFailed',
);

export const taskCreated = createAction<{
  taskId: GDriveImportJob['taskId'];
  directUploadingId: GDriveImportJob['directUploadingId'];
  link: GDriveImportJob['link'];
  parentNodeId: GDriveImportJob['parentNodeId'];
  createdAt: GDriveImportJob['createdAt'];
}>('creativeHub/googleDriveImport/taskCreated');

export const taskProgressChanged = createAction<{
  taskId: GDriveImportJob['taskId'];
  progress: number;
}>('creativeHub/googleDriveImport/taskProgressChanged');

export const taskSucceeded = createAction<{ taskId: GDriveImportJob['taskId'] }>(
  'creativeHub/googleDriveImport/taskSucceeded',
);

export const taskFailed = createAction<{
  taskId: GDriveImportJob['taskId'];
  errorMessage: string;
}>('creativeHub/googleDriveImport/taskFailed');

export const jobViewerClosed = createAction('creativeHub/googleDriveImport/jobViewerClosed');
